import NAVSLOT_QUERY from '../cms/nav/queries/NAVSLOT_QUERY';
import { useQuery } from '@apollo/client';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';


const DynamicMenu = () => {
    const { data: slot } = useQuery(NAVSLOT_QUERY, {
        variables: {
            navSlotSlug: 'global-nav',
        }
    });
    const renderItems = () => {
        const items = slot?.navigation?.menu?.items;
        if (items) {
            return items.map((i: any) => <LinkContainer key={i.id} to={i.uri}><Nav.Link>{i.label}</Nav.Link></LinkContainer>)
        }
        return null;
    }
    return <Nav className="me-auto">
        {renderItems()}
    </Nav>;
};

export default DynamicMenu;
